import { decrypt, encrypt } from "src/app/shared/util-encrypt";

export abstract class StorageService implements Storage {

  constructor(protected readonly api: Storage) { }
  [name: string]: any;
  length: number;

  setItem(key: string, value: string): void {
    let data = encrypt(value);
    this.api.setItem(key, data);
  }

  getItem(key: string): string | null {
    let data = this.api.getItem(key);
    if (data !== null) {
      return decrypt(data!);
    }
    return null;
  }

  removeItem(key: string): void {
    this.api.removeItem(key);
  }

  clear(): void {
    this.api.clear();
  }

  key(index: number): string | null {
    let data = this.api.key(index);
    if (data !== null) {
      return decrypt(data!);
    }
    return null;
  }
}
